import * as React from 'react'

// NOTE: all modules imported below may be imported from '@silevis/reactgrid'
import {
  Cell,
  CellStyle,
  CellTemplate,
  Compatible,
  Span,
  Uncertain,
  getCellProperty
} from '@silevis/reactgrid'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { ReactComponent as Information } from 'assets/svg/Information.svg'

export interface CustomHeaderCell extends Cell, Span {
  type: 'header'
  text: string
  tooltipText?: string
  required: boolean
}

export class CustomHeaderCellTemplate
  implements CellTemplate<CustomHeaderCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<CustomHeaderCell>
  ): Compatible<CustomHeaderCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string')
    const required = getCellProperty(uncertainCell, 'required', 'boolean')
    const value = parseFloat(text)
    const tooltipText = getCellProperty(uncertainCell, 'tooltipText', 'string')
    return { ...uncertainCell, text, value, tooltipText, required }
  }

  render(cell: Compatible<CustomHeaderCell>): React.ReactNode {
    return (
      <div className="row gap-8 align-center">
        <div className="row gap-4">
          {cell.text}
          {cell.required && <span className="required" />}
        </div>
        {cell.tooltipText && (
          <Tooltip title={cell.tooltipText}>
            <Information />
          </Tooltip>
        )}
      </div>
    )
  }

  isFocusable = (): boolean => false

  getClassName(cell: Compatible<CustomHeaderCell>): string {
    return cell.className ? cell.className : ''
  }

  getStyle = (): CellStyle => ({ background: 'rgba(128, 128, 128, 0.1)' })
}
